import * as React from 'react';
import { cn } from '../../lib/cn';

export const AppShell = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'flex min-h-screen w-full bg-background text-foreground antialiased',
        className,
      )}
      {...props}
    />
  ),
);
AppShell.displayName = 'AppShell';

export const AppMain = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <main
      ref={ref}
      className={cn('flex min-h-screen flex-1 flex-col overflow-hidden', className)}
      {...props}
    />
  ),
);
AppMain.displayName = 'AppMain';

export const AppContent = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('flex-1 overflow-auto p-6', className)} {...props} />
  ),
);
AppContent.displayName = 'AppContent';
